import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      icon: 'ShieldCheck',
      title: '256-bit SSL',
      description: 'Bank-grade encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Payments',
      description: 'PCI DSS compliant'
    },
    {
      icon: 'RefreshCw',
      title: 'Money Back',
      description: '7-day guarantee'
    },
    {
      icon: 'Headphones',
      title: '24/7 Support',
      description: 'Always here to help'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {trustBadges?.map((badge, index) => (
        <div key={index} className="flex flex-col items-center text-center p-3 md:p-4 bg-card rounded-lg shadow-warm">
          <div className="p-2 md:p-3 bg-primary/10 rounded-full mb-2 md:mb-3">
            <Icon name={badge?.icon} size={20} color="var(--color-primary)" />
          </div>
          <h4 className="text-xs md:text-sm font-caption font-semibold mb-1">{badge?.title}</h4>
          <p className="text-xs text-muted-foreground">{badge?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;